// Import Packages
import React, {useState, useEffect} from "react";
import {useTranslation} from "react-i18next";
import HTMLReactParser from "html-react-parser";

// Import Material UI
import Grid from "@material-ui/core/Grid";
import {Checkbox, CircularProgress, InputLabel} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Divider from '@material-ui/core/Divider';
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {withStyles} from '@material-ui/core/styles';

// Import Pages
import ApplicationService from "../../../../../services/ApplicationService/ApplicationService";
import Condition from "../../../../FlowConfigurationInputs/Condition/Condition";
import ConnectorField from "../../../../../home/pages/automs/newFlow/middleArea/connectorField/ConnectorField";

// Import CSS
import './Setup.css';

const GreenCheckbox = withStyles({
    root: {
        color: '#9b9b9b',
        '&$checked': {
            color: '#43aa41',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default function Setup({
                                  variables,
                                  setOpenVariable,
                                  handleSetSelectedSetup,
                                  checked,
                                  setChecked,
                                  triggerConfig,
                                  setTriggerConf,
                                  automId,
                                  automVersionId
                              }) {
    const [progressStatus, setProgressStatus] = useState(true);
    const [showCondition, setShowCondition] = useState(false);
    const [conditions, setConditions] = useState([]);
    const [setupFields, setSetupFields] = useState([]);
    const [form, setForm] = useState({});
    const {t} = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.TRIGGER-STATIC.SETUP."
    const labelGeneralTimeOptions = "GENERAL.TIME-OPTIONS."

    useEffect(() => {
        initializeFieldsValue();
        fetchData().then(r => r);
        if (checked) {
            setShowCondition(true);
            setTimeout(function () {
                setProgressStatus(false);
            }, 500);
        }
    }, []);

    const fetchData = async () => {
        const response = await ApplicationService.getApplicationTriggerSetup({
            id: triggerConfig?.trigger?.id,
            credential_id: triggerConfig?.connector?.id
        });
        if (response && response.status && Object.keys(response.data).length > 0) {
            const data = response.data;
            setSetupFields(data.setup_fields);

            if (!conditions.length) {
                const tempCond = JSON.parse(JSON.stringify(conditions));
                if (triggerConfig.setup.conditions.length) setConditions(triggerConfig.setup.conditions)
                else setConditions(addEmptyCondition(tempCond))
            }

        }
    }

    const initializeFieldsValue = () => {
        const stateFields = JSON.parse(JSON.stringify(triggerConfig.setup.fields));
        setForm(stateFields);
    }

    const addEmptyCondition = (cond) => {
        cond.push({
            "source": [],
            "condition": "",
            "target": "",
            "op_logic": ""
        });

        return cond;
    }

    const resetCondition = () => {
        const scratchCond = addEmptyCondition([]);
        setConditions(scratchCond);
        handleSetSelectedSetup({fields: form, conditions: []});
    }

    const deleteCondition = (index) => {
        const tempCond = JSON.parse(JSON.stringify(conditions));
        tempCond.splice(index, 1);
        if (tempCond.length < 2) {
            tempCond[0]["op_logic"] = "";
        }
        setConditions(tempCond);

        handleSetSelectedSetup({fields: form, conditions: tempCond});
    }

    const handleShowCondition = () => {
        if (checked) {
            resetCondition();
        }
        setTimeout(function () {
            if (checked) {
                setProgressStatus(true);
            } else {
                setProgressStatus(false);
            }
        }, 500);
        setChecked(!checked);
        setShowCondition(!showCondition);
    }

    const changeField = async (key, value) => {
        let fields = {...form};
        fields[key] = value;
        setForm(fields);
        handleSetSelectedSetup({fields, conditions})
    }

    const checkVisible = (field) => {
        if (!field.visible) {
            if (field.depends !== '') {
                const arrName = field.depends.split('.');
                return form[arrName[0]] === arrName[1]
            }
        }
        return field.visible;
    }

    const setStringField = (key, value) => {
        let fields = {...form};
        fields[key] = value;
        setForm(fields);
        handleSetSelectedSetup({fields, conditions})
    }

    const setConditionField = async (field, value, index) => {
        let tempCond = JSON.parse(JSON.stringify(conditions));
        tempCond[index][field] = value;

        if (field === "op_logic") {
            tempCond = addEmptyCondition(tempCond);
        }
        setConditions(tempCond);

        handleSetSelectedSetup({
            "fields": form,
            "conditions": tempCond
        });

    }


    return (
        <>
            {showCondition &&
                <ConnectorField showFieldPreview={checked} triggerConfig={triggerConfig} triggerExpanded={true}
                                debugOpen={false} debugExpand={false} onFlowPage={false} setTriggerConf={setTriggerConf}
                                automId={automId}
                                automVersionId={automVersionId} rightLocation={false} variables={variables}
                                setOpenVariable={setOpenVariable}/>
            }
            <div className="trigger-connector-container">

                <div className="trigger-setup-container">
                    <Grid container spacing={3} className="setup-grid-container">
                        <div className="create-setup-container">
                            <Grid item xs={12} sm={12} md={12}
                                  className="visible">
                                <>
                                    <label
                                        className="create-setup-label">{t(label + "ADDITIONAL-FIELDS")}</label>
                                    <Divider
                                        style={{margin: '12px 0px 25px -10px', backgroundColor: 'rgb(208 208 210)'}}/>

                                    {setupFields?.map(field => {
                                        const key = field.identifier;
                                        if (checkVisible(field)) {
                                            switch (field.type) {
                                                case 'string':
                                                case 'password':
                                                case 'email':
                                                    return (
                                                        <div className="form-element setup-element">
                                                            <div className="modal-text add-autom">
                                                                <div>{t(label + field.display_name)}</div>
                                                            </div>
                                                            <TextField
                                                                id="filled-size-small"
                                                                type={field.type}
                                                                value={form[key]}
                                                                onChange={(e) => setStringField(key, e.target.value)}
                                                                className="input"
                                                                variant="outlined"
                                                                size="small"
                                                                inputProps={{
                                                                    style: {
                                                                        fontSize: 15,
                                                                        paddingLeft: 15,
                                                                        backgroundColor: '#f7f7f7'
                                                                    }
                                                                }}
                                                            />
                                                            {field.help_available && (
                                                                <small
                                                                    className="help-text">{t(label + field.display_name + '-HELP')}</small>
                                                            )}
                                                        </div>
                                                    )
                                                case 'single_select':
                                                    return <div className="form-element setup-element">
                                                        <div className="modal-text"
                                                             style={{marginBottom: 5}}>{t(label + field.display_name)}</div>
                                                        <FormControl
                                                            variant="outlined"
                                                            style={{width: "100%"}}
                                                        >
                                                            <Select
                                                                displayEmpty
                                                                labelId="demo-simple-select-outlined-label"
                                                                style={{
                                                                    backgroundColor: "#f7f7f7",
                                                                    height: "41px",
                                                                    fontSize: "15px",
                                                                    marginBottom: 15
                                                                }}
                                                                id="demo-simple-select-outlined"
                                                                matmazel={key}
                                                                value={form[key] || ""}
                                                                onChange={(e) => changeField(key, e.target.value)}
                                                            >
                                                                <MenuItem key={0} value="" style={{fontSize: 12}}>
                                                                    {t(`${label}${field.placeholder}`)}
                                                                </MenuItem>
                                                                {field.options.length > 0 &&
                                                                    field.options?.map((item, index) => (
                                                                        <MenuItem
                                                                            style={{fontSize: 12}}
                                                                            key={index}
                                                                            value={item.value}
                                                                        >
                                                                            {t(`${labelGeneralTimeOptions}${item.display_name}`)}
                                                                        </MenuItem>
                                                                    ))}
                                                            </Select>
                                                            {field.help_available && (
                                                                <small
                                                                    className="help-text">{t(label + field.display_name + '-HELP')}</small>
                                                            )}
                                                        </FormControl>
                                                    </div>
                                                case "datetime":
                                                    return (
                                                        <div className="form-element setup-element">
                                                            <div className="modal-text"
                                                                 style={{marginBottom: 5}}>{t(label + field.display_name)}</div>
                                                            <FormControl
                                                                variant="outlined"
                                                                style={{width: "100%"}}
                                                            >
                                                                <TextField type="datetime-local" fullWidth
                                                                           value={form[key]}
                                                                           style={{
                                                                               backgroundColor: "#f7f7f7",
                                                                               height: "41px",
                                                                               fontSize: "15px",
                                                                               marginBottom: "15px"
                                                                           }}
                                                                           variant="outlined"
                                                                           onChange={(e) => changeField(key, e.target.value)}
                                                                           InputLabelProps={{shrink: true}} size="small"
                                                                />
                                                            </FormControl>
                                                        </div>
                                                    )
                                                case 'guide':
                                                    return HTMLReactParser(field.default_value)
                                                default:
                                                    return (<div/>)
                                            }
                                        }
                                    })}
                                </>
                            </Grid>
                        </div>
                    </Grid>
                    <Grid container spacing={3} className="setup-grid-container">
                        <div className="create-setup-container">
                            <Grid item xs={12} sm={12} md={12}
                                  className="visible">
                                <div className="condition-pane">
                                    <FormControlLabel
                                        control={<GreenCheckbox checked={checked} onChange={handleShowCondition}
                                                                name="checkedG"/>}
                                        label={t(label + "HAS-CONDITION")}
                                    />

                                </div>
                            </Grid>
                        </div>
                    </Grid>

                    {showCondition && (
                        <Grid container spacing={3} className="setup-grid-container">
                            <div className="create-setup-container">
                                <Grid item xs={12} sm={12} md={12}
                                      className="visible">
                                    {progressStatus ? (
                                        <div className="progress-loader">
                                            <CircularProgress/>
                                            <span>{t('CONTENT.AUTH-PAGES.LOADING')}</span>
                                        </div>
                                    ) : (
                                        <>
                                            <Condition triggerConfig={triggerConfig} conditions={conditions}
                                                       deleteCondition={deleteCondition}
                                                       setConditionField={setConditionField}
                                                       setConditions={setConditions}
                                                       addEmptyCondition={addEmptyCondition}
                                                       setOpenVariable={setOpenVariable} variables={variables}/>
                                        </>
                                    )}

                                </Grid>
                            </div>
                        </Grid>
                    )}

                </div>
            </div>
        </>

    )
}
